import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Services = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  // Initialize accordion functionality
  useEffect(() => {
    const initAccordion = () => {
      const accordionContainers = document.querySelectorAll(".ul-accordion");
      
      accordionContainers.forEach(accordionContainer => {
        const accordionItems = accordionContainer.querySelectorAll(".ul-single-accordion-item");
        
        accordionItems.forEach((accordionItem) => {
          // Skip if already initialized
          if (accordionItem.hasAttribute('data-accordion-initialized')) {
            return;
          }
          
          accordionItem.setAttribute('data-accordion-initialized', 'true');
          
          const header = accordionItem.querySelector(".ul-single-accordion-item__header");
          if (header) {
            header.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              
              const openedItems = accordionContainer.querySelector(".ul-single-accordion-item.open");
              
              if (accordionItem.classList.contains("open")) {
                accordionItem.classList.remove("open");
              } else {
                accordionItem.classList.add("open");
                if (openedItems && openedItems !== accordionItem) {
                  openedItems.classList.remove("open");
                }
              }
            });
          }
        });
      });
    };

    // Initialize immediately and also after a short delay to ensure DOM is ready
    initAccordion();
    const timeoutId = setTimeout(initAccordion, 100);
    
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Our Programs</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Our Programs</li>
          </ul>
        </div>
      </section>

      <section className="ul-section-spacing overflow-hidden">
        <div className="ul-container">
          <div className="row row-cols-md-3 row-cols-2 row-cols-xxs-1 ul-bs-row">

            <div className="col">
              <div className="ul-service ul-service--inner">
                <div className="ul-service-img">
                  <img
                    src="/assets/new-img/teacher-explaining-the-work-of-solar-panel-to-stud-2025-02-11-18-50-44-utc.jpg"
                    alt="Service Image"
                  />
                </div>
                <div className="ul-service-txt">
                  <h3 className="ul-service-title">
                    <Link to="/service-details?program=health-literacy"
                      >Health Literacy Education</Link
                    >
                  </h3>
                  <p className="ul-service-descr">
                    We create clear, accurate, and engaging educational content
                    on common chronic conditions such as diabetes, hypertension,
                    asthma, and mental health. Our content is science-based,
                    easy to understand, visually engaging, and social media
                    friendly. Available in Uzbek, Russian, Mandarin, Spanish,
                    and English.
                  </p>
                  <Link
                    to="/service-details?program=health-literacy"
                    className="ul-service-btn"
                    ><i className="flaticon-up-right-arrow"></i> View Details</Link
                  >
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-service ul-service--inner">
                <div className="ul-service-img">
                  <img
                    src="/assets/new-img/high-school-students-raising-hands-in-classroom-du-2025-03-05-05-09-38-utc.jpg"
                    alt="Service Image"
                  />
                </div>
                <div className="ul-service-txt">
                  <h3 className="ul-service-title">
                    <Link to="/pathio-buddies"
                      >Student Development & Mentorship</Link
                    >
                  </h3>
                  <p className="ul-service-descr">
                    Pathio supports aspiring healthcare professionals by
                    offering mentorship, skills development, research-based
                    learning, content creation experience, and exposure to
                    public health communication. Our goal is to create
                    meaningful pathways into health careers while improving
                    science literacy across communities.
                  </p>
                  <Link
                    to="/pathio-buddies"
                    className="ul-service-btn"
                    ><i className="flaticon-up-right-arrow"></i> View Details</Link
                  >
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-service ul-service--inner">
                <div className="ul-service-img">
                  <img
                    src="/assets/new-img/presenting-renewable-sources-of-energy-2025-03-17-06-37-43-utc.jpg"
                    alt="Service Image"
                  />
                </div>
                <div className="ul-service-txt">
                  <h3 className="ul-service-title">
                    <a to="/service-details?program=resource-connection"
                      >Community Resource Connection</a
                    >
                  </h3>
                  <p className="ul-service-descr">
                    Pathio connects people to real, local health
                    resources—including free or low-cost clinics, screenings,
                    services, and support programs available in New York City's
                    underserved neighborhoods. Interactive maps and QR-ready
                    cards filtered by language, borough, and services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ul-why-join ul-section-spacing pt-0">
        <div className="ul-why-join-wrapper ul-section-spacing">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 gy-4 align-items-center">
              <div className="col">
                <div className="ul-why-join-img">
                  <img
                    src="/assets/new-img/happy-volunteers-putting-hands-together-wearing-gl-2025-10-05-19-19-30-utc.jpg"
                    alt="Image"
                  />
                </div>
              </div>

              <div className="col">
                <div className="ul-why-join-txt">
                  <span className="ul-section-sub-title">Join us</span>
                  <h2 className="ul-section-title">
                    Why We Need You: Mentors, Creators & Partners
                  </h2>
                  <p className="ul-section-descr">
                    Whether you're a healthcare mentor, student creative,
                    community member, school partner, or funder—Pathio has a
                    path for you to make a real impact.
                  </p>

                  <div className="ul-accordion">
                    <div className="ul-single-accordion-item open">
                      <div className="ul-single-accordion-item__header">
                        <div className="left">
                          <h3 className="ul-single-accordion-item__title">
                            Healthcare Professionals
                          </h3>
                        </div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>

                      <div className="ul-single-accordion-item__body">
                        <p>
                          Share professional perspective, career insight, and lived experience to support Pathio's student-led mentorship, awareness efforts, and navigation initiatives.
                        </p>
                      </div>
                    </div>

                    <div className="ul-single-accordion-item">
                      <div className="ul-single-accordion-item__header">
                        <div className="left">
                          <h3 className="ul-single-accordion-item__title">
                            Community Partners & Organizations
                          </h3>
                        </div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>

                      <div className="ul-single-accordion-item__body">
                        <p>
                          Collaborate with Pathio on outreach, programming, or resource connection efforts that support students and communities navigating healthcare pathways and access to care.
                        </p>
                      </div>
                    </div>

                    <div className="ul-single-accordion-item">
                      <div className="ul-single-accordion-item__header">
                        <div className="left">
                          <h3 className="ul-single-accordion-item__title">
                            Content & Media Contributors
                          </h3>
                        </div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>

                      <div className="ul-single-accordion-item__body">
                        <p>
                          Support storytelling, design, and communications that highlight student experiences, healthcare journeys, and community awareness initiatives.
                        </p>
                      </div>
                    </div>

                    <div className="ul-single-accordion-item">
                      <div className="ul-single-accordion-item__header">
                        <div className="left">
                          <h3 className="ul-single-accordion-item__title">
                            Volunteers
                          </h3>
                        </div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>

                      <div className="ul-single-accordion-item__body">
                        <p>
                          Assist with events, outreach, operations, or behind-the-scenes support that strengthens Pathio's mentorship, navigation, and awareness-focused work.
                        </p>
                      </div>
                    </div>

                    <div className="ul-single-accordion-item">
                      <div className="ul-single-accordion-item__header">
                        <div className="left">
                          <h3 className="ul-single-accordion-item__title">
                            Supporters & Donors
                          </h3>
                        </div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>

                      <div className="ul-single-accordion-item__body">
                        <p>
                          Help sustain Pathio's student-led programs, community initiatives, and long-term impact by supporting our mission financially or strategically.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>

      <Footer />
    </>
  );
};

export default Services;
